import { ButtonLink, Reveal, SectionLabel } from "@/components/common";
import { FullscreenUI, Laptop } from "@/components/media/Frames";
import { ICONS } from "@/lib/icons";
import { cn } from "@/lib/utils";

export const Highlight = ({ data, number, id, frame = "fullscreen", ctaType, reverse }) => {
  const Frame = frame === "laptop" ? Laptop : FullscreenUI;
  return (
    <section id={id} data-testid={`${id}-section`} className="relative overflow-hidden py-24 md:py-36">
      <div className="container-x">
        <div className={cn("grid items-center gap-14 lg:grid-cols-12 lg:gap-20")}>
          <div className={cn("lg:col-span-5", reverse && "lg:order-2 lg:col-start-8")}>
            <SectionLabel number={number}>{data.eyebrow}</SectionLabel>
            <h2 className="mt-6 font-display text-4xl leading-[1] sm:text-5xl lg:text-6xl">{data.title}</h2>
            <p className="mt-8 border-l-2 border-turq pl-6 text-lg leading-relaxed text-fg/90 md:text-xl" data-testid={`${id}-message`}>{data.message}</p>
            <div className="mt-10">
              <ButtonLink to={`/contact?type=${ctaType}`} testId={`${id}-cta`}>Describe your problem</ButtonLink>
            </div>
          </div>
          <Reveal className={cn("lg:col-span-7", reverse && "lg:order-1")}>
            {data.image && <Frame src={data.image} alt={`${data.eyebrow} — example interface`} />}
          </Reveal>
        </div>
        <ul className="mt-20 grid grid-cols-2 gap-px overflow-hidden rounded-md border border-line/10 bg-line/10 sm:grid-cols-3 lg:grid-cols-4" data-testid={`${id}-tiles`}>
          {data.tiles.map((t, i) => {
            const Icon = ICONS[t.icon] || ICONS.Sparkles;
            return (
              <li key={t.title} className="group flex min-h-[132px] flex-col justify-between gap-6 bg-canvas p-5 transition-colors duration-300 hover:bg-surface md:p-7">
                <div className="flex items-start justify-between">
                  <Icon className="h-5 w-5 text-silver transition-colors duration-300 group-hover:text-turq" aria-hidden />
                  <span className="font-mono text-[10px] text-gold">{String(i + 1).padStart(2, "0")}</span>
                </div>
                <p className="text-sm font-medium leading-snug md:text-base">{t.title}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};
